import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OrganizationEmloyeePageData from '../../../Models/Content/OrganizationEmloyeePageData';
import OrgEmployeePageMain from './OrganizationEmployeeMain';

export default class OrganizationEmloyeePage extends EpiComponent<OrganizationEmloyeePageData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (
          <OrgEmployeePageMain iContent={this.props.data}/>
      )
    }
}
